import React from 'react';
import { 
  Box, 
  Typography, 
  IconButton
} from '@mui/material';
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';

const RecipeServings = ({ 
  servings, 
  setServings,
  hasEnhancedMeasurements
}) => {
  if (!hasEnhancedMeasurements) return null;
  
  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'row',
      gap: 2,
      mt: 0.5,
      mb: 0.5,
      p: 2,
      bgcolor: 'background.paper',
      borderRadius: 1,
      alignItems: 'center',
      position: 'relative',
      zIndex: 1
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography component="label" htmlFor="servings" variant="body2">
          Servings:
        </Typography>
        <IconButton 
          size="small" 
          onClick={() => setServings(Math.max(1, servings - 1))}
          disabled={servings <= 1}
        >
          <RemoveCircleOutline fontSize="small" />
        </IconButton>
        <Typography variant="body1" sx={{ minWidth: '20px', textAlign: 'center' }}>
          {servings}
        </Typography>
        <IconButton 
          size="small" 
          onClick={() => setServings(servings + 1)}
        >
          <AddCircleOutline fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default RecipeServings; 